import { Component, Inject, Input, OnInit } from '@angular/core';
import { FiltrosRequisicaoFinanceira, RelatorioRequisicaoFinanceira } from '@app/models/relatorio-rpv-precatorio.model';
import { IdDescricao } from '@app/models/util/id-descricao';
import { UtilitarioService } from '@app/services/utilitario.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-precatorio-relatorio',
  templateUrl: './precatorio-relatorio.component.html'
})
export class PrecatorioRelatorioComponent {
  @Input() lstOrgaosJudiciario: IdDescricao[];

  filtros: FiltrosRequisicaoFinanceira = new FiltrosRequisicaoFinanceira();
  relatorioItens: RelatorioRequisicaoFinanceira[] = [];

  totalRequisicoes: number = 0;
  totalBruto: number = 0;
  totalLiquido: number = 0;
  
  dataEmissao: Date;

  pesquisando: boolean = false;

  constructor(
    private relatorioService: RelatorioService,
    @Inject(ToastrService) private toastr: ToastrService
  ) 
  { 
    this.filtros.Precatorio = true;
  }

  pesquisar(){
    this.pesquisando = true;
    this.dataEmissao = new Date();
    this.relatorioService.obterRelatorioRequisicaoFinanceira(this.filtros).subscribe(
      (data) => {
        if(data.length > 0){
          this.relatorioItens = data;
          this.somaTotais();
        }
        else
          this.toastr.info('Pesquise novamente com outros filtros.', 'Registros não encontrados!');
        this.pesquisando = false;
      }
    )
  }

  changeEstadoAndamento(elementoHTMLId: string){
    const elemento =  document.getElementById(elementoHTMLId) as HTMLInputElement;

    if(!elemento.checked)
      return;

    switch(elementoHTMLId){
      case 'HomologadoCheckBox':
        this.filtros.Autuado = false;
        this.filtros.Recebido = false; 
        break;
      case 'AutuadoCheckBox':
        this.filtros.Homologado = false;
        this.filtros.Recebido = false;
        break;
      case 'RecebidoCheckBox': 
        this.filtros.Homologado = false;
        this.filtros.Autuado = false;
        break;
    }
  }

  somaTotais(){
    this.totalRequisicoes = 0;
    this.totalBruto = 0;
    this.totalLiquido = 0;

    this.relatorioItens.forEach(item => {
      this.totalRequisicoes += item.ValorRequerido;
      this.totalBruto += item.ValorBrutoEscritorio;
      this.totalLiquido += item.ValorLiquidoEscritorio;
    })
  }

  imprimir(){
    let conteudo = document.getElementById("precatorio").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório Precatório", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    objetoFiltros.set('Emitido em', this.dataEmissao.toLocaleString());
    
    adicionaMapValido("TipoData", this.filtros.TipoData);

    parseDateAdicionaMap('Data Inicial', this.filtros.DataInicial);
    parseDateAdicionaMap('Data Final', this.filtros.DataFinal);    

    obtemDescricaoAdicionaMap('Comarca', this.lstOrgaosJudiciario, this.filtros.OrgaoJudiciarioId);
    
    adicionaBooleano("Somente Sucumbências", this.filtros.Sucumbencia);
    adicionaBooleano("Somente Homologados", this.filtros.Homologado);
    adicionaBooleano("Somente Recebidos", this.filtros.Recebido);
    adicionaBooleano("Somente Autuados", this.filtros.Autuado);
    
    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaBooleano(chave: string, valor: boolean){
      if(valor)
        adicionaMapValido(chave, 'SIM');
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

}
